<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="ri-bank-card-line"></i>
          {{ $t("public.views.Pages.Payment.payment") }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mr-2" style="right" variant="primary" @click="goToDashboard">{{
          $t("public.views.Pages.Payment.btnBack")
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <div v-if="action === 'cancel'" class="text-center">
          <h4 class="text-danger">{{ $t("public.views.Pages.Payment.problemPay") }}</h4>
          <i class="fas fa-exclamation-circle fa-8x text-danger"></i>
        </div>
        <div v-if="action === 'success'" class="text-center">
          <h4 class="text-success">{{ $t("public.views.Pages.Payment.paidCorrectly") }}</h4>
          <i class="fas fa-check-circle fa-8x text-success"></i>
        </div>
        <b-row>
          <h4 class="title-typography-color">{{ $t("public.views.Pages.Payment.paymentData") }}</h4>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group v-if="user" label-for="mode">
              <template slot="label">{{ $t("public.views.Pages.Payment.payMode") }}:</template>
              <ul class="list-group">
                <li v-if="mode === 'PAYPAL'" class="list-group-item">
                  <i class="fab fa-cc-paypal mr-2"></i> PayPal
                </li>
              </ul>
              <ul class="list-group">
                <li v-if="mode === 'STRIPE'" class="list-group-item">
                  <i class="fab fa-cc-stripe mr-2"></i> Stripe
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col v-if="paymentId" cols="6">
            <b-form-group v-if="user" label-for="mode">
              <template slot="label">{{ $t("public.views.Pages.Payment.paymentId") }}:</template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ paymentId }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <h4 class="title-typography-color">{{ $t("public.views.Pages.Payment.invoiceData") }}</h4>
        </b-row>
        <b-row>
          <b-col v-if="user && user.name" cols="6">
            <b-form-group label-for="name">
              <template slot="label">{{ $t("public.views.Pages.Payment.name") }}:</template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ user.name }} {{ user.lastname }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col v-if="user && user.document" cols="6">
            <b-form-group label-for="document">
              <template slot="label">{{ $t("public.views.Pages.Payment.document2") }}:</template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ user.document }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col v-if="user && user.country" cols="6">
            <b-form-group label-for="country">
              <template slot="label">{{ $t("public.views.Pages.Payment.country") }}:</template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ user.country }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col v-if="user && user.postalCode" cols="6">
            <b-form-group label-for="postalCode">
              <template slot="label">{{ $t("public.views.Pages.Payment.postalCode") }}:</template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ user.postalCode }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col v-if="user && user.address" cols="6">
            <b-form-group label-for="address">
              <template slot="label">{{ $t("public.views.Pages.Payment.address") }}:</template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ user.address }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import utilsService from "../../services/utils";
import userService from "../../services/user";
import patientService from "../../services/patient";

export default {
  name: "Payment",
  components: {},
  mounted() {
    this.getUser();

    utilsService.auditActivity({ action: "VIEW", module: "GENERIC_PAYMENT", info: "" });
  },
  data() {
    return {
      user: {},
      action: this.$route.query.action,
      mode: this.$route.query.mode,
      tokenback: this.$route.query.tokenback,
      paymentId: this.$route.query.paymentId,
      tokenPaypal: this.$route.query.token,
      payerId: this.$route.query.PayerID,
      //Pay event:
      iprosEventId: this.$route.query.iprosEventId,
    };
  },
  computed: {
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  methods: {
    //Pay
    paySuccess(patientId, id, mode, token, data) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.paySuccess(patientId, id, mode, token, data),
        (response) => {
          utilsService.auditActivity({ action: "UPDATE", module: "GENERIC_PAYMENT", info: "" });
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Payment.notification.title"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Payment.notification.descPay"
            ),
            type: "success",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.paySuccess",
            module: "view-pages-payment",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              patientId: patientId, id: id, mode: mode, token: token, data: data
            })
          });
        },
        " "
      );
    },
    async verifyPayPaypal() {
      //Paypal and success
      if (
        this.user.id &&
        this.tokenPaypal &&
        this.tokenback &&
        this.paymentId &&
        this.payerId &&
        this.iprosEventId &&
        this.mode === "PAYPAL" &&
        this.action === "success"
      ) {
        let data = {
          tokenPaypal: this.tokenPaypal,
          paymentIdPaypal: this.paymentId,
          payerIDPaypal: this.payerId,
        };

        this.paySuccess(
          this.user.id,
          this.iprosEventId,
          this.mode,
          this.tokenback,
          data
        );
      }
    },
    async verifyStripe() {
      //Stripe and success
      if (
        this.user.id &&
        this.tokenback &&
        this.iprosEventId &&
        this.mode === "STRIPE" &&
        this.action === "success"
      ) {
        let data = {
          tokenPaypal: "",
          paymentIdPaypal: "",
          payerIDPaypal: "",
        };

        this.paySuccess(
          this.user.id,
          this.iprosEventId,
          this.mode,
          this.tokenback,
          data
        );
      }
    },
    goToDashboard() {
      if (this.user.role === "PATIENT") {
        this.$router.push({
          name: "auth.patient.dashboard",
        });
      } else {
        this.$router.push({
          name: "auth.professional.dashboard",
        });
      }
    },
    async getUser() {
      let self = this;

      this.$awn.asyncBlock(
        userService.get(localStorage.getItem("userId")),
        (response) => {
          if (response) {
            self.user = response.data;

            self.verifyPayPaypal();
            self.verifyStripe();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "userService.get",
            module: "view-pages-payment",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        },
        " "
      );
    },
  },
};
</script>
